export default __webpack_public_path__ + "static/media/Andi.8e1b03b8.jpg";